/**
 * Local storage key for whether the LinkedIn account error popup should always be open if the
 * account is in an error state.
 */
export const HAS_DISMISSED_ACCOUNT_ERROR_STATUS_STORAGE_KEY = 'dontAutoShowAccountErrorStatus';
